import { ArrowPathIcon } from '@heroicons/react/24/outline';

const Loader = () => (
  <div className="min-h-screen flex items-center justify-center bg-gray-50">
    <ArrowPathIcon className="w-12 h-12 text-[#0c8842] animate-spin" />
  </div>
);
export default Loader